// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"12":"31fc124c","615":"7edf1e71"}[chunkId] + ".chunk.js";
};